program supportweb;

{$R *.dres}

uses
  Vcl.Forms,
  WEBLib.Forms,
  form.main in 'form.main.pas'{*.html},
  db.connection in 'db.connection.pas',
  form.APIProcessStatus in 'form.APIProcessStatus.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateFormDirect(TdmData, dmData);
  Application.CreateForm(TfrmMain, frmMain);
  Application.CreateForm(TfrmAPIProcessStatus, frmAPIProcessStatus);
  Application.Run;
end.
